function getGlobal() {
  if (typeof window !== 'undefined') {
    return window;
  }
  if (typeof globalThis !== 'undefined') {
    return globalThis;
  }
  return undefined;
}

export function getStoredToken() {
  const globalRef = getGlobal();
  if (!globalRef) {
    return null;
  }
  try {
    return globalRef.sessionStorage?.getItem('token') || globalRef.localStorage?.getItem('token') || null;
  } catch (error) {
    console.warn('[auth] unable to read token from storage', error);
    return null;
  }
}

export function clearStoredToken() {
  const globalRef = getGlobal();
  if (!globalRef) {
    return;
  }
  try {
    globalRef.sessionStorage?.removeItem('token');
  } catch (error) {
    console.warn('[auth] unable to clear session token', error);
  }
  try {
    globalRef.localStorage?.removeItem('token');
  } catch (error) {
    console.warn('[auth] unable to clear local token', error);
  }
}

export function decodeTokenPayload(token) {
  if (!token) {
    return null;
  }
  const globalRef = getGlobal();
  if (!globalRef || (typeof globalRef.atob !== 'function' && typeof atob !== 'function')) {
    return null;
  }
  const [header, payload] = token.split('.');
  if (!payload) {
    return null;
  }
  try {
    const normalized = payload.replace(/-/g, '+').replace(/_/g, '/');
    const padLength = (4 - (normalized.length % 4)) % 4;
    const padded = normalized.padEnd(normalized.length + padLength, '=');
    const decoder = typeof globalRef.atob === 'function' ? globalRef.atob.bind(globalRef)
      : typeof atob === 'function' ? atob : null;
    if (!decoder) {
      return null;
    }
    const jsonPayload = decoder(padded);
    return JSON.parse(jsonPayload);
  } catch (error) {
    console.warn('[auth] failed to decode token payload', error);
    return null;
  }
}

export function getCurrentUser() {
  const token = getStoredToken();
  if (!token) {
    return null;
  }
  const payload = decodeTokenPayload(token);
  if (!payload) {
    return null;
  }
  if (payload.exp && typeof payload.exp === 'number') {
    const expiresAt = payload.exp * 1000;
    if (Number.isFinite(expiresAt) && Date.now() >= expiresAt) {
      return null;
    }
  }
  return payload;
}

export function isAdmin() {
  return getCurrentUser()?.role === 'admin';
}
